<template>
  <g>
    <g v-if="activeHohlschnitt && materialComplete">
      <path :d="'M75 75 q30 175 0 350 q175 -30 350 0 q' + cXhohlschnitt + ' ' + cYhohlschnitt + ' -350 -350'" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
      <polygon v-for="(corner, index) in hohlschnitt" :key="index" :points="corner.point" :transform="'rotate(' + corner.rotate + ')'" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <polygon v-else points="75,75 75,425 425,425" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === rand.keder.title.name" stroke="#b1b1b1" stroke-opacity="0">
          <polygon :points="side.keder.outside" fill="#b1b1b1"/>
          <polygon :points="side.keder.inside" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      cXhohlschnitt: -175 - Math.sqrt(450),
      cYhohlschnitt: -175 + Math.sqrt(450),
      hohlschnitt: {
        cornerLU: {
          point: '70,80 70,70 80,70',
          rotate: '20 75 75'
        },
        cornerLD: {
          point: '70,420 70,430 80,430',
          rotate: '0'
        },
        cornerRD: {
          point: '430,420 430,430 420,430',
          rotate: '-20 425 425'
        }
      }
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'activeHohlschnitt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: 90,
            xEnd: 410 - Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } else if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M75 395 L395 395',
          hohlsaum: 'M75 416 L416 416',
          keder: {
            outside: '75,416 75,425 425,425 416,416',
            inside: '75,422 75,425 425,425 422,422'
          },
          labelSpace: {
            x: 250,
            y: 455
          },
          labelBackground: {
            x: 215,
            y: 437,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 465,
              xEnd: 425,
              yEnd: 465
            },
            corner: {
              start: '75,465 85,460 85,470',
              rotateStart: 'rotate(0, 75, 465)',
              end: '425,465 415,460 415,470',
              rotateEnd: 'rotate(0, 425, 465)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            yStart: 90 + Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            yEnd: 410,
            x: function (i, item) {
              return 90
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M105 105 L105 425',
          hohlsaum: 'M84 84 L84 425',
          keder: {
            outside: '75,75 75,425 84,425 84,84',
            inside: '75,75 75,425 78,425 78,78'
          },
          labelSpace: {
            x: 35,
            y: 250
          },
          labelBackground: {
            x: 0,
            y: 231,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 35,
              yStart: 75,
              xEnd: 35,
              yEnd: 425
            },
            corner: {
              start: '35,75 30,85 40,85',
              rotateStart: 'rotate(0, 35, 75)',
              end: '35,425 30,415 40,415',
              rotateEnd: 'rotate(0, 35, 425)'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: 90,
            yStart: 90 + Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            xEnd: 410 - Math.sqrt(Math.pow(15, 2) + Math.pow(15, 2)),
            yEnd: 410,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } else if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M75 ' + (75 + this.spaceRand(30, 30)) + ' L' + (425 - this.spaceRand(30, 30)) + ' 425',
          hohlsaum: 'M75 ' + (75 + this.spaceRand(9, 9)) + ' L' + (425 - this.spaceRand(9, 9)) + ' 425',
          keder: {
            outside: '75,75 75,' + (75 + this.spaceRand(9, 9)) + ' ' + (425 - this.spaceRand(9, 9)) + ',425 425,425',
            inside: '75,75 75,' + (75 + this.spaceRand(3, 3)) + ' ' + (425 - this.spaceRand(3, 3)) + ',425 425,425'
          },
          labelSpace: {
            x: 290,
            y: 210
          },
          labelBackground: {
            x: 257,
            y: 195,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 453.284271247,
              yStart: 396.715728753,
              xEnd: 103.284271247,
              yEnd: 46.7157287525
            },
            corner: {
              start: '453.284271247,396.715728753 448.284271247,386.715728753 458.284271247,386.715728753',
              rotateStart: 'rotate(-45, 453.284271247, 396.715728753)',
              end: '103.284271247,46.7157287525 98.284271247,56.7157287525 108.284271247,56.7157287525',
              rotateEnd: 'rotate(-45, 103.284271247, 46.7157287525)'
            }
          },
          id: 3
        }
      }
    }
  }
}
</script>

<style>
</style>
